import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared';
import { CONFIG } from '../../shared/config';
import { StoreExaminationCommitteeStp } from './store-examination-committee-stp';
let StoreExaminationCommitteeStpUrl = CONFIG.baseUrls.StoreExaminationCommitteeStp;

@Injectable({
  providedIn: 'root'
})
export class StoreExaminationCommitteeStpService {

  constructor(private httpGeneralService: HttpGeneralService) { }

  addStoreExaminationCommitteeStp(StrExaminationCommittee: StoreExaminationCommitteeStp[]) {
    return this.httpGeneralService.add(StrExaminationCommittee, `${StoreExaminationCommitteeStpUrl}/StoreExaminationCommitteeStp`)
  }

  getStoreExaminationCommitteeStp(StoreCode: number) {
    return this.httpGeneralService.getWith(`${StoreExaminationCommitteeStpUrl}/${StoreCode}/StoreExaminationCommitteeStpLoad`)
  }

  deleteStoreExaminationCommitteeStp(StrExaminationCommittee: any) {

    return this.httpGeneralService.delete(StrExaminationCommittee.serial, `${StoreExaminationCommitteeStpUrl}/StoreExaminationCommitteeStpdelete`)

  }
}
